<template lang="html">
  <div class="calendar-wrapper">
    <calendar
      v-model="time"
      :schedule="days"
      :fullDays="full"
      :count="count"
      :defaultDate="selectedTime"
      :isAvailable="isAvailable"
    ></calendar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import calendar from '../date'
import datePrompt from '../date/prompt'
import { SKUTAG } from '@/plugins/enum'
import utils from '@/plugins/utils'

export default {
  data() {
    return {
      time: '',
      count: 6,
      isAvailable: false
    }
  },
  created() {
    this.getUnworkDay(this.count)
  },
  components: {
    calendar,
    datePrompt
  },
  computed: {
    ...mapState([
      'selectedTime',
      'selectedWorker',
      'unworkDays',
      'workDays',
      'fullDays',
      'selectedAddress',
      'confirmProduct'
    ]),
    days() {
      // if (this.selectedWorker.workerCode) {
      //     this.isAvailable = true
      //     return this.workDays
      // } else {
      this.isAvailable = true
      return this.workDays
      // }
    },
    full() {
      if (this.selectedWorker.workerCode) {
        return this.fullDays
      } else {
        return []
      }
    },
    skuTag() {
      return (
        this.confirmProduct &&
        this.confirmProduct.skuInfo &&
        this.confirmProduct.skuInfo.skuTag
      )
    },
    isPopYuesao() {
      return this.skuTag == SKUTAG.POPYUSAO
    },
    isPopStore() {
      return this.skuTag == SKUTAG.POPSTORE
    },
    isApplianceWash() {
      return this.skuTag == SKUTAG.APPLIANCE_WASHING
    }
  },
  watch: {
    async time(val, oldVal) {
      if (!val.disabled && val.isFull) {
        this.$$toast('当前排期已满')
        return
      }
      if (this.time.disabled) {
        // this.$$toast('该时间不可服务')
      } else {
        this.$store.commit('setSelectedTime', this.time.time)
        // this.$store.commit('');
        if (this.$route.query.action) {
          this.$router.go(-1)
        } else {
          this.$store.commit('hideActionSheet', false)
        }
        // 选择完时间筛选服务人员
        let areaCode = ''
        if (
          this.selectedAddress.regionid &&
          this.selectedAddress.regionid !== ''
        ) {
          areaCode = this.selectedAddress.regionid.split('_')[2]
        }
        // if (!this.selectedWorker.workerCode && !this.isPopStore) {
        //     console.log(444);
        //     await this.$store.dispatch('getWorkers', {
        //         spuId: this.$route.params.spuId,
        //         serviceDate: this.time.time,
        //         districtId: areaCode
        //     })
        // }

        this.$$tracker('110101', '10000', 21045, this.selectedTime)
      }
    }
  },
  methods: {
    async getUnworkDay(month) {
      // console.log(this.selectedWorker)
      if (this.isPopYuesao) {
        //联营月嫂前端自生成服务时间
        this.getUserWorkDayS(month)
      } else if (this.isPopYuesao) {
        //家电洗护前端自生成服务时间
        this.getUserWorkDayS(month)
      } else if (!this.isPopStore) {
        await this.$store.dispatch('getUserWorkDayBySpu', {
          month,
          workerCode: this.selectedWorker.workerCode,
          spuId: this.$route.params.spuId || '',
          districtId:
            this.selectedAddress.regionid &&
            this.selectedAddress.regionid.split('_')[2]
        })
      } else {
        //pop到店前端自生成服务时间

        this.getUserWorkDayS(month)
      }
    },
    async getCount(month) {
      await this.getUnworkDay(month + 6)
      this.count += 6
    },
    async getUserWorkDayS(count) {
      const dataList = []
      for (let i = 0; i <= count; i++) {
        const beginDate = new Date()
        const countTime = beginDate.setMonth(beginDate.getMonth() + i)
        const countDay = new Date(countTime)

        const attr = utils.dateFormat(countDay, 'YY-MM')
        const Y = attr.split('-')[0]
        const M = attr.split('-')[1]
        const days = new Date(Y, M, 0).getDate()
        const vs = []
        for (let j = 0; j < days; j++) {
          vs.push(1)
        }
        const obj = {
          [attr]: vs
        }
        dataList.push(obj)
      }
      const now_day = new Date().getDate()
      const otherDays = []
      for (let i = 1; i < now_day; i += 1) {
        const d = i < 10 ? `0${i}` : i
        otherDays.push(
          `${utils.dateFormat(new Date().getTime(), 'YY-MM')}-${d}`
        )
      }
      const workDays = []
      dataList.forEach(dayData => {
        // debugger;
        // console.log(dayData)
        const monthKey = Object.keys(dayData)[0]
        const arr = dayData[monthKey]
        // console.log(arr);
        const workDayArr = arr.filter(x => x === 0)
        if (workDayArr.length !== arr.length) {
          // 整个月都没排
          arr.forEach((ele, index) => {
            if (ele === 1) {
              const day = `${index + 1}`.padStart(2, '0')
              const workDay = `${monthKey}-${day}`
              if (!otherDays.includes(workDay)) {
                workDays.push(workDay)
              }
            }
          })
        }
      })
      this.$store.commit('setWorkDays', workDays)

      //})
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.calendar-wrapper {
  min-height: 100%;
  // padding-bottom: rem(100px);
}
.date-prompt-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: rem(20px) rem(55px);
  z-index: 20;
  background: #f4f4f4;

  .date-prompt {
    @include border(all, #e6e6e6, 1px, 4px);
  }
}
</style>
